import { forwardRef, type ReactNode } from "react";
import { motion } from "framer-motion";
import { pageFade } from "./variants";

/**
 * Page-level entrance/exit wrapper. Wrap each page's root (or the page-head +
 * first section) so the whole page crossfades in on mount and out on unmount.
 * Pair with <AnimatePresence> in AppShell (PageTransition is the keyed child)
 * for route transitions. Forwards its ref to the motion.div so AnimatePresence
 * mode="popLayout" can measure/pop the exiting page.
 */
export const PageTransition = forwardRef<HTMLDivElement, {
  children: ReactNode;
  className?: string;
  delay?: number;
}>(function PageTransition({ children, className, delay = 0 }, ref) {
  return (
    <motion.div
      ref={ref}
      className={className}
      variants={pageFade}
      initial="hidden"
      animate="show"
      exit="exit"
      transition={delay ? { delay } : undefined}
    >
      {children}
    </motion.div>
  );
});